import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import DropDownInput from "../../../component/Input/dropDownInput/dropDownInput";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import SearchLocation from "../../searchLocation/searchLocation";
import { toast } from "react-toastify";
import FileUpload from "../../FileUploads/FileUpload";
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
const ReferralCreate = ({
    getProjectTypes,
    projectTypes=[],
    createNewReferral,
    saveReferral=[],
    documentUploadUrlPublic,
    documentUrlDataPublic,
    locationPinCode,
    pincodeData,
    locationCity,
    locationZone,
    locationArea,
    cities = [],
    zones = [],
    areas = [],
    history
}) => {
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [roleId, setRoleId] = useState('');
    const [dropdownProjectTypes, setDropdownProjectTypes] = useState([]);
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [pincodeValue, setPincodeValue] = useState('');
    const [pincode, setPincode] = useState([]);
    const [isAllow, setIsAllow] = useState(false);
    const [long, setLong] = useState('');
    const [lat, setLat] = useState('');
    const [haveReferralLocation, setHaveReferralLocation] = useState('');
    const [city, setCity] = useState('');
    const [geostate, setGeostate] = useState('');

    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });

    const [formValues, setFormValues] = useState({
        project_type_id: '',
        client_name: '',
        longitude:'',
        latitude:'',
        role_id:roleId,
        address:'',
        pincode:'',
        team_id:'',
        spoc_details: [
            {
                name: '',
                number: '',
                email: '',
                designation:''
            }
        ],
        referral_giver_name: '',
        referral_giver_number: '',
        referral_giver_email: '',
        referral_giver_designation:'',
        referral_giver_site_id:''
    });

    useEffect(() => {
        const roleId = localStorage.getItem('role_id');
        setRoleId(roleId);
        handleInputChange(null,{ target: { name: 'role_id', value: roleId } });
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const res = await getProjectTypes();
            setDropdownProjectTypes(res);
            await locationCity();
            setIsLoading(false);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        const lati = Number(islatlng?.lat);
        const langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: lati,
                lng: langi,
            });
        }
    }, [islatlng]);

    useEffect(() => {
        if (pincodeValue === ''){
             return;
        }
        const fetchPincodeData = async () => {
            let res = await locationPinCode(pincodeValue);
            setCity(res[0]?.city_name !== undefined ? res[0]?.city_name : '')
            setGeostate(res[0]?.state_name !== undefined ? res[0]?.state_name : '')
            handleInputChange(null,{ target: { name: 'pincode', value: pincodeValue } });
            handleInputChange(null,{ target: { name: 'geographical_city_id', value: res[0]?.geo_city_id } });
            handleInputChange(null,{ target: { name: 'geographical_state_id', value: res[0]?.geo_state_id } });
        };
        fetchPincodeData();
    }, [pincodeValue]);

    useEffect(() => {
        setPincode([]);
        if (pincodeData && pincodeData.length > 0) {
            setPincode(pincodeData[0]);
        }
    }, [pincodeData]);

    const addPOC = () => {
        setFormValues(prevState => ({
            ...prevState,
            spoc_details: [...prevState.spoc_details, { name: '', number: '', email: '',designation:'' }]
        }));
    };
    
    const removePOC = (index) => {
        if (formValues.spoc_details.length > 1) {
            setFormValues(prevState => ({
                ...prevState,
                spoc_details: prevState.spoc_details.filter((_, i) => i !== index)
            }));
        } else {
            toast.error('At least one SPOC is required.');
        }
    };

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng) {
            setLong(latlng?.lng);
            setLat(latlng?.lat);
            // Ensure handleInputChange is properly called
            handleInputChange(null,{ target: { name: 'longitude', value: latlng?.lng } });
            handleInputChange(null,{ target: { name: 'latitude', value: latlng?.lat } });
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({ ...optOption, currentLocation: value });
        handleInputChange(null, { target: { name: 'address', value } });

    };

    

    const handleInputChange = (index, e) => {
        if(e && (e.target!=null || e.target!=undefined)){
            const { name, value, files } = e.target;
        
            if (index !== null) {
                // Handling dynamic fields in spoc_details
                const fieldName = name.split('_')[2]; // Extracting field name from name attribute
                setFormValues(prevState => {
                    const newSpocDetails = [...prevState.spoc_details];
                    newSpocDetails[index] = { ...newSpocDetails[index], [fieldName]: value };
                    return { ...prevState, spoc_details: newSpocDetails };
                });
            } else {
                // Handling singular fields
                setFormValues(prevState => ({
                    ...prevState,
                    [name]: value
                }));
            }
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSuccessModalOpen(false)
        setIsFailedModalOpen(false)
        if (formValues?.spoc_details.length === 0) {
            toast.error('At least one SPOC is required.');
            return;
        }
        if (formValues?.address==''||formValues?.address==undefined) {
            toast.error('Location is required');
            return;
        }
        formValues.spoc_details.forEach((spoc, index) => {
            if (!spoc?.name || !spoc?.number || !spoc?.email) {
                toast.error(`Please fill out all fields for SPOC ${index + 1}`);
                return;
            }
        });
        
        setIsLoading(true);
        const res = await createNewReferral(formValues);
        if (res) {
            setIsSuccessModalOpen(true)
        }else{
            setIsFailedModalOpen(true)
        }
        setIsLoading(false);
        
    };

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={'Referral created successfully'}
                url={'referrals-status'}
            />
            <FailedModal
                isOpen={isFailedModalOpen}
                msg={'Something went wrong'}
                url={'new-referral'}
            />
            <Loader isLoading={isLoading} />
            <div id="wrapper">
                <DashboardMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header title={'Drop a New Referral'} />
                        <div className="container-fluid">
                            <div className="col-md-10 col-lg-8 mx-auto mt-4">
                                <div className="bg-white p-4 rounded shadow-sm border">
                                    <h1 className="h4 mb-4 text-primary">Drop a New Referral</h1>
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label htmlFor="team_id" className="form-label">
                                                Select Team <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control"
                                                id="team_id"
                                                name="team_id"
                                                value={formValues.team_id}
                                                onChange={e => handleInputChange(null, e)}
                                                required
                                            >
                                                <option value="">Choose...</option>
                                                {dropdownProjectTypes?.teams?.map(team => (
                                                    <option key={team.id} value={team.id}>
                                                        {team.team_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        <div className="mb-3">

                                            <label htmlFor="project_type_id" className="form-label">
                                                Select Project Type <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control"
                                                id="project_type_id"
                                                name="project_type_id"
                                                value={formValues.project_type_id}
                                                onChange={e => handleInputChange(null, e)}
                                                required
                                            >
                                                <option value="">Choose...</option>
                                                {dropdownProjectTypes?.project_types?.map(projectType => (
                                                    <option key={projectType.id} value={projectType.id}>
                                                        {projectType.project_type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        <div className="mb-3">
                                            <label htmlFor="client_name" className="form-label">
                                                Client Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="client_name"
                                                name="client_name"
                                                className="form-control"
                                                value={formValues.client_name}
                                                onChange={e => handleInputChange(null, e)}
                                                placeholder="Enter client name"
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <FileUpload
                                                id={`addAttachment`}
                                                accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                onChange={(e) => {
                                                    handleInputChange(null, { target: { name: 'attachment', value: e } });
                                                }}
                                                required={false}
                                                multiple={true}
                                                prefilledFilename={""}
                                            >
                                                Add Attachment
                                            </FileUpload>
                                        </div>

                                        <SearchLocation
                                            handleCurrentLocationBlur={handleCurrentLocationBlur}
                                            value={optOption.currentLocation}
                                            handleCurrentLocationChange={handleCurrentLocationChange}
                                            // isView={}
                                            setPincodeValue={setPincodeValue}
                                        />
                                        <div className="col-sm-6 float-field mt-1">
                                            <input type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(val) => {
                                                    handleInputChange(null, { target: { name: 'lat', val } });
                                                }}
                                                value={lat}
                                                required
                                                disabled={true}
                                            />
                                            <label className="large-label float-lb">
                                                Latitude <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                        <div className="col-sm-6 float-field mt-1">
                                            <input type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(val) => {
                                                    handleInputChange(null, { target: { name: 'long', val } });
                                                }}
                                                value={long}
                                                required
                                                disabled={true}
                                            />
                                            <label className="large-label float-lb">
                                                Longitude <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                        <div className="col-sm-6 float-field mt-1">
                                            <input type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                required
                                                value={formValues?.address}
                                                disabled={true}
                                            />
                                            <label className="large-label float-lb">
                                                Address Line <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                        <div className="col-sm-6 float-field mt-1">
                                            <input type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                required
                                                value={pincodeValue}
                                                disabled={false}
                                                onChange={(event) => {
                                                    setPincodeValue(event.target.value);
                                                }}
                                            />
                                            <label className="large-label float-lb">
                                                Pincode <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                        <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                                            <input type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                disabled
                                                value={city}
                                                required
                                            />
                                            <label className="large-label float-lb">
                                                Geographical City <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                        <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                                            <input type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                disabled
                                                value={geostate}
                                                required
                                            />
                                            <label className="large-label float-lb">
                                                Geographical State <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                        {/* <div className="mb-3">
                                            <SearchLocation
                                                handleCurrentLocationBlur={handleCurrentLocationBlur}
                                                value={optOption.currentLocation || ''}
                                                handleCurrentLocationChange={handleCurrentLocationChange}
                                                label={"Dealer Location"}
                                                setPincodeValue={setPincodeValue}
                                            />
                                        </div> */}
                                        {formValues.spoc_details.map((poc, index) => (
                                            <div key={index} className="mb-4 p-3 border rounded bg-light">
                                                <h5 className="mb-3 text-primary">POC {index + 1}</h5>
                                                <div className="mb-3">
                                                    <label htmlFor={`spoc_name_${index}`} className="form-label">
                                                        SPOC Name <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id={`spoc_name_${index}`}
                                                        name={`spoc_details_name_${index}`}
                                                        className="form-control"
                                                        value={poc.name}
                                                        onChange={(e) => handleInputChange(index, e)}
                                                        placeholder="Enter SPOC name"
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor={`spoc_number_${index}`} className="form-label">
                                                        SPOC Number <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id={`spoc_number_${index}`}
                                                        name={`spoc_details_number_${index}`}
                                                        className="form-control"
                                                        value={poc.number}
                                                        onChange={(e) => handleInputChange(index, e)}
                                                        placeholder="Enter SPOC number"
                                                        required
                                                        pattern="\d{10}"
                                                        title="SPOC number must be 10 digits"
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor={`spoc_email_${index}`} className="form-label">
                                                        SPOC Email <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        id={`spoc_email_${index}`}
                                                        name={`spoc_details_email_${index}`}
                                                        className="form-control"
                                                        value={poc.email}
                                                        onChange={(e) => handleInputChange(index, e)}
                                                        placeholder="Enter SPOC email"
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor={`spoc_designation_${index}`} className="form-label">
                                                        SPOC Designation <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id={`spoc_designationl_${index}`}
                                                        name={`spoc_details_designation_${index}`}
                                                        className="form-control"
                                                        value={poc.designation}
                                                        onChange={(e) => handleInputChange(index, e)}
                                                        placeholder="Enter SPOC Designation"
                                                        required
                                                    />
                                                </div>
                                                {formValues.spoc_details.length > 1 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => removePOC(index)}
                                                    >
                                                        Remove POC
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        <button
                                            type="button"
                                            className="btn btn-primary mb-4"
                                            onClick={addPOC}
                                        >
                                            Add POC
                                        </button>
                                        <div className="mb-4 p-3 border rounded bg-light">
                                        <h5 className="mb-3 text-primary">Details of the Person who gave the Referral</h5>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`referral_giver_name`}
                                                    name={`referral_giver_name`}
                                                    className="form-control"
                                                    value={formValues.referral_giver_name}
                                                    onChange={e => handleInputChange(null, e)}
                                                    placeholder="Enter Name"
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Phone Number
                                                </label>
                                                <input
                                                    type="text" 
                                                    id="referral_giver_number"
                                                    name="referral_giver_number"
                                                    className="form-control"
                                                    value={formValues.referral_giver_number}
                                                    onChange={e => handleInputChange(null, e)}
                                                    placeholder="Enter Phone Number"
                                                    pattern="\d{10}"
                                                    title="Phone number must be 10 digits"
                                                    maxLength="10"
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Email
                                                </label>
                                                <input
                                                    type="email"
                                                    id={`referral_giver_email`}
                                                    name={`referral_giver_email`}
                                                    className="form-control"
                                                    value={formValues.referral_giver_email}
                                                    onChange={e => handleInputChange(null, e)}
                                                    placeholder="Enter Email"
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Designation <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`referral_giver_designation`}
                                                    name={`referral_giver_designation`}
                                                    className="form-control"
                                                    value={formValues.referral_giver_designation}
                                                    onChange={e => handleInputChange(null, e)}
                                                    placeholder="Enter Designation"
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="team_id" className="form-label">
                                                    Site Name 
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <DropDownInput
                                                    data={dropdownProjectTypes?.sites}
                                                    hideLabel={true}
                                                    getIdValue={(val) => {
                                                        setFormValues(prevState => ({
                                                            ...prevState,
                                                            'referral_giver_site_id': val.id
                                                        }));
                                                    }}
                                                    // required = {true}
                                                />
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <button type="submit" className="btn btn-primary btn-lg w-100">
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReferralCreate;